const NotificationType = {
  EmailOnly: 'EmailOnly',
  TextOnly: 'TextOnly',
  BothTextAndEmail: 'BothTextAndEmail',
} as const;

const DayOfWeek = {
  MONDAY: 'MONDAY',
  TUESDAY: 'TUESDAY',
  WEDNESDAY: 'WEDNESDAY',
  THURSDAY: 'THURSDAY',
  FRIDAY: 'FRIDAY',
  SATURDAY: 'SATURDAY',
  SUNDAY: 'SUNDAY',
} as const;

const Frequency = {
  Weekly: 'Weekly',
  DayBeforeDueDate: 'DayBeforeDueDate',
  DayOfDueDate: 'DayOfDueDate',
} as const;

export const CandidateCommunicationAlertsConst = {
  NotificationType,
  DayOfWeek,
  Frequency,
} as const;
